// Mirrors backend/src/utils/lineItems.js so the totals shown while editing match what
// the server will store. If the tax/discount rule changes, change both.

export const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

export const computeTotals = (items = [], discount = 0) => {
  const rows = items.map((raw) => {
    const quantity = Number(raw.quantity) || 0;
    const unitPrice = Number(raw.unitPrice) || 0;
    const taxPercent = Number(raw.taxPercent) || 0;
    const lineSubtotal = round2(quantity * unitPrice);
    const lineTax = round2((lineSubtotal * taxPercent) / 100);
    return { ...raw, quantity, unitPrice, taxPercent, lineSubtotal, lineTax, lineTotal: round2(lineSubtotal + lineTax) };
  });

  const subtotal = round2(rows.reduce((sum, i) => sum + i.lineSubtotal, 0));
  const taxTotal = round2(rows.reduce((sum, i) => sum + i.lineTax, 0));
  const discountAmount = round2(Math.min(Number(discount) || 0, subtotal));

  return { items: rows, subtotal, taxTotal, discountAmount, total: round2(subtotal - discountAmount + taxTotal) };
};

export const emptyLineItem = () => ({ description: '', quantity: 1, unitPrice: 0, taxPercent: 18 });

export const formatCurrency = (amount, currency = 'INR') =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency, maximumFractionDigits: 2 }).format(Number(amount) || 0);

export const formatDate = (value) =>
  value ? new Date(value).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '-';

// Value for a date <input type="date">, which needs YYYY-MM-DD and nothing else.
export const toDateInput = (value) => (value ? new Date(value).toISOString().split('T')[0] : '');
